import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { successToast } from "../../Utils/utils";

export var deleteCourse = function(courseId, btn:boolean|JQuery=false){
    if (btn){
        btn.prop('disabled', true);
    }

    const success = function(data){
        successToast("Kurs wurde gelöscht", "Erfolg", 5000);
          setTimeout(() => {
            location.reload();
          }, 750);
    }

    const url = '/course/' + courseId.toString() + '/delete'

    ajaxRequest(url, success, {}, btn)

  }